// extracted by mini-css-extract-plugin
module.exports = {"comparison":"styles_comparison__vmfgu","clip":"styles_clip___4zAr"};